import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import {
  getTotalManPower,
  getTotalManPowerInDetail,
} from "../../redux/reducers/dashboardReducers";
import { Grid } from "@material-ui/core";
import { Text, SVG } from "sunrise-ui";

import List from "./List";
import { useEffect } from "react";

const TotalManpower = (props: any) => {
  const dispatch = useDispatch<AppDispatch>();

  const totalManpower = useSelector(
    (state: any) => state.DASHBOARD.totalManPower
  );
  const totalManpowerInDetail = useSelector(
    (state: any) => state.DASHBOARD.totalManPowerInDetail
  );
  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);

  useEffect(() => {
    console.log(totalManpower);

    if (Array.isArray(allProject)) {
      const project_id: any = allProject?.find(
        (val: any) => val?.projectName === props?.projectName
      )?._id;
      if (project_id) {
        dispatch(
          getTotalManPower({
            endPoint: `project/manpower?project=${project_id}`,
          })
        );
        dispatch(
          getTotalManPowerInDetail({
            endPoint: `project/manpower?project=${project_id}&count=true`,
          })
        );
      }
    }
    // eslint-disable-next-line
  }, [props?.projectName]);

  const fields = [
    {
      header: "Name",
      search: true,
      value: "name",
    },
    {
      header: "Designation",
      search: true,
      value: "designation",
    },
    {
      header: "Global Rank",
      value: "globalRank",
      search: true,
    },
    {
      header: "Project Rank",
      value: "projectRank",
      search: true,
    },
    {
      header: "Current Status",
      value: "currentStatus",
      search: true,
    },
    {
      header: "Started Working on Project",
      search: true,
      value: "startedWorkingOnProject",
    },
  ];

  return (
    <div>
      <Grid item xs={12}>
        <Grid container className="pt1">
          {/* ------Completed piles --- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center mr-1">
            <Grid className="mr">
              <SVG type={"Manpower"} />
            </Grid>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Total Manpower
              <br />
              in Project: {totalManpowerInDetail?.totalManpowerInProject}
            </Text>
          </Grid>
          {/* ------Total Pile Length------- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center mr-1">
            <Grid className="mr">
              <SVG type={"totalEngineer"} />
            </Grid>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Total Engineers
              <br />
              in Project: {totalManpowerInDetail?.totalEngineer}
            </Text>
          </Grid>
          {/* ------ Maximum No of Delay causing agency ------- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center mr-1">
            <Grid className="mr">
              <SVG type={"totalSubContractor"} />
            </Grid>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Total Sub-
              <br />
              Contractors in
              <br />
              Project: {totalManpowerInDetail?.totalSubContractor}
            </Text>
          </Grid>
          {/* ------Maximum delay causing agency in hrs------- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center mr-1">
            <Grid className="icon_container complete_icon mr">
              <SVG type={"operator"} />
            </Grid>
            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Total Operator
              <br />
              in Project: {totalManpowerInDetail?.totalOperators}
            </Text>
          </Grid>
          {/* ------Overall delay in project------- */}
          <Grid className="p1 box--shadow bg--white small_info_card d-flex h-center v-center">
            <Grid className="mr">
              <span>
                <SVG type={"otherStuff"} />
              </span>
            </Grid>

            <Text
              type="normal"
              fonts="normal"
              fontSize={18}
              className="mb0 mt0 fw400 line-height1"
            >
              Others in
              <br />
              Project: {totalManpowerInDetail?.otherStaff}
            </Text>
          </Grid>
        </Grid>
      </Grid>
      {/* -------------- 1st row ---------------- */}

      <Grid container>
        <List
          listData={totalManpower}
          dataToDownLoad={totalManpower}
          fields={fields}
          title={`Total Manpower for ${props.projectName} Project`}
          sizeType="small"
          nodataText="There is no data available for Total Manpower"
          project={props.projectName}
        />
      </Grid>
    </div>
  );
};

export default TotalManpower;
